import React from "react";

import { st, Accordion } from "lib/index";

class ProductVariantsListing extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      activeIndex: null,
    };
  }
  handleOpenAccordion = (e, { index }) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { product, isProductVariantValid, renderProductVariant } = this.props;
    const { activeIndex } = this.state;
    if (product.product_variants.length === 1) {
      return renderProductVariant(product.product_variants[0]);
    } else {
      return (
        <div className="field">
          <Accordion exclusive={false} styled fluid defaultActiveIndex={st.range(0, product.product_variants.length)}>
            {product.product_variants.map((product_variant) => [
              <Accordion.Title
                className={
                  isProductVariantValid && !isProductVariantValid(product_variant) ? "title--error" : undefined
                }
                active={activeIndex === product_variant.id}
                index={product_variant.id}
                onClick={this.handleOpenAccordion}
              >
                {product_variant.name || I18n.t("papp.common.no_name")} <i className="icon dropdown"></i>
              </Accordion.Title>,
              <Accordion.Content active={activeIndex === product_variant.id}>
                {renderProductVariant(product_variant)}
              </Accordion.Content>,
            ])}
          </Accordion>
        </div>
      );
    }
  }
}

export default ProductVariantsListing;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/ProductVariantsListing.jsx